export const createArrayRange = (start = 0, stop = 20, step = 1) =>
  Array.from({ length: (stop - start) / step + 1 }, (_value, index) => start + index * step);
